<template>
  <iColumn
    align="center"
    vertical-align="middle"
    gap="large"
    width="fill"
    height="fill"
    :data-test="isJoiningOrWaiting ? 'call-connecting' : 'call-empty-state'"
  >
    <iAvatar
      v-if="isJoiningOrWaiting"
      :name="displayName"
      size="extraLarge"
      pulse
    />
    <iIcon
      v-else
      name="ic:outline-videocam-off"
      size="large"
      variant="subtle"
    />
    <iColumn align="center" gap="extraSmall" width="hug">
      <iText
        font-size="large"
        font-weight="dark"
        text-align="center"
      >
        {{ headline }}
      </iText>
      <iText variant="subtle" text-align="center">
        {{ message }}
      </iText>
    </iColumn>
    <iButton
      v-if="isJoiningOrWaiting && canCancel"
      variant="text"
      size="small"
      data-test="call-cancel-join"
      @click="$emit('cancel')"
    >
      Cancel
    </iButton>
  </iColumn>
</template>

<script>
export default {
  name: "CallEmptyState",
  props: {
    headline: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
    isJoiningOrWaiting: {
      type: Boolean,
      default: false,
    },
    displayName: {
      type: String,
      default: "You",
    },
    canCancel: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["cancel"],
};
</script>
